import React, { ChangeEvent } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IGroupItemLeafUI } from "@models/IGroupSubsectionUI";

type Props = {
    leaf: IGroupItemLeafUI;
    updateLeafFn: (leaf: IGroupItemLeafUI) => void;
    removeLeafFn: (leaf: IGroupItemLeafUI) => void;
    id: string;
    isActive?: boolean;
    isDragOverlay?: boolean;
};

export const MultiProductGroupLeaf = (props: Props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props.id,
        data: { type: "multi-group-leaf" },
    });

    const style = props.isDragOverlay
        ? { position: "relative" as const, zIndex: 1000, opacity: 0.9 }
        : {
              transform: CSS.Transform.toString(transform),
              transition,
              opacity: isDragging ? 0.6 : 1,
              position: "relative" as const,
              zIndex: isDragging ? 1 : ("auto" as const),
          };

    const activeStyles = props.isActive
        ? {
              background: "#f7f9fc",
              boxShadow: "0 0 10px rgba(0,0,0,0.15)",
              border: "1px dashed #007bff",
              borderRadius: "4px",
              padding: "4px",
          }
        : {};

    const overlayStyles = props.isDragOverlay
        ? {
              background: "#ffffff",
              boxShadow: "0 5px 16px rgba(0,0,0,0.2)",
              opacity: 0.9,
              border: "1px solid #007bff",
              borderRadius: "4px",
              padding: "4px",
          }
        : {};

    const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) => {
        props.updateLeafFn({ ...props.leaf, group_title: e.target.value });
    };

    return (
        <div
            className={"MultiProductGroupLeaf d-flex align-items-center mb-1"}
            ref={setNodeRef}
            style={{ ...style, ...activeStyles, ...overlayStyles }}
            {...attributes}>
            <div className="drag-handle me-2" {...listeners}>
                <i className="fas fa-grip-lines" />
            </div>
            <i
                className={`fas fa-trash-alt me-2 pointer ${props.leaf.deleteFlag ? "text-secondary" : "text-danger"}`}
                onClick={() => props.removeLeafFn(props.leaf)}
            />
            <span className={`me-3 text-muted small ${props.leaf.deleteFlag ? "text-decoration-line-through" : ""}`}>
                {props.leaf.Catalog_Item?.name ?? props.leaf.name ?? props.leaf.Catalog_Item?.sku ?? props.leaf.sku}
            </span>
            <input
                type="text"
                className={"form-control form-control-sm ms-auto"}
                style={{ maxWidth: "200px" }}
                value={props.leaf.group_title ?? ""}
                onChange={handleTitleChange}
                maxLength={100}
                placeholder={"label"}
                disabled={!!props.leaf.deleteFlag}
            />
        </div>
    );
};
